  // Payment Types
  export const PAYMENT_TYPES = {
    CHECK: 'check',
    FINANCE: 'finance',
    CARD: 'card',
    CASH: 'cash',
  };
  
  // Refund Steps
  export const REFUND_STEPS = {
    PAYMENT_METHOD: 'paymentMethod',
    FORM: 'form',
    SP_PAY_DEDUCTION: 'spPayDeduction',
  };
  
  // Validation Limits
  export const VALIDATION_LIMITS = {
    CHECK_NUMBER: {
      MIN: 3,
      MAX: 20,
    },
    FINANCING_NUMBER: {
      MIN: 6,
      MAX: 30,
    },
  };
  
  // Common Colors
  export const COLORS = {
    REQUIRED_ASTERISK: '#ff4d4f',
    TEXT_PRIMARY: '#333',
    TEXT_SECONDARY: '#666',
    TEXT_MUTED: '#8c8c8c',
    BORDER_LIGHT: '#e8e8e8',
    BORDER_LIGHTER: '#f0f0f0',
    BACKGROUND_LIGHT: '#fafafa',
    ORANGE_PRIMARY: '#ff6b35',
    ORANGE_LIGHT: '#fff5f0',
  };
  
  // Common Button Style
  export const commonButtonStyle = {
    minWidth: '110px',
    height: '42px',
    padding: '0 28px',
    fontSize: '15px',
    fontWeight: 500,
    borderRadius: '6px',
    whiteSpace: 'nowrap',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  };
  
  // Form Input Styles
  export const inputStyle = {
    fontSize: '15px',
    borderRadius: '4px',
    width: '100%',
  };
  
  export const inputLargeStyle = {
    ...inputStyle,
    height: '42px',
  };
  
  export const inputMediumStyle = {
    ...inputStyle,
    height: '35px',
  };
  
  export const textAreaStyle = {
    fontSize: '15px',
    padding: '12px 14px',
    borderRadius: '4px',
    width: '100%',
    minHeight: '100px',
  };
  
  // Form Label Style
  export const formLabelStyle = {
    fontSize: '15px',
    fontWeight: 500,
    color: COLORS.TEXT_PRIMARY,
    display: 'block',
  };
  
  // Form Item Common Props
  export const formItemProps = {
    required: false,
    labelCol: { span: 24 },
    wrapperCol: { span: 24 },
    style: { marginBottom: '12px' },
  };
  
  // Footer Container Style (for buttons)
  export const footerContainerStyle = {
    marginTop: '40px',
    paddingTop: '24px',
    borderTop: `1px solid ${COLORS.BORDER_LIGHT}`,
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    width: '100%',
    gap: '14px',
  };
  
  // Payment Methods List (for RefundPaymentMethodSelection)
  export const PAYMENT_METHODS = [
    { key: PAYMENT_TYPES.CHECK, labelKey: 'text.report.check', fallback: 'Check' },
    { key: PAYMENT_TYPES.FINANCE, labelKey: 'text.report.financing', fallback: 'Financing' },
    { key: PAYMENT_TYPES.CARD, labelKey: 'text.report.creditCard', fallback: 'Credit Card' },
    { key: PAYMENT_TYPES.CASH, labelKey: 'text.report.cash', fallback: 'Cash' },
  ];

  // Radio Button Base Style (for SP Pay Deduction)
  export const radioButtonBaseStyle = {
    fontSize: '16px',
    fontWeight: 500,
    padding: '14px 32px',
    borderRadius: '8px',
    minWidth: '120px',
    textAlign: 'center',
    cursor: 'pointer',
    transition: 'all 0.3s ease',
  };
    
  // Function to get radio button style based on selection state
  export const getRadioButtonStyle = (isSelected) => ({
    ...radioButtonBaseStyle,
    border: isSelected ? `2px solid ${COLORS.ORANGE_PRIMARY}` : `2px solid #e0e0e0`,
    backgroundColor: isSelected ? COLORS.ORANGE_LIGHT : COLORS.BACKGROUND_LIGHT,
    boxShadow: isSelected ? '0 2px 8px rgba(255, 107, 53, 0.15)' : 'none',
  });